import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { HrAssistantIconComponent } from '../hr-assistant-icon/hr-assistant-icon.component';

@Component({
  selector: 'hr-assistant-trigger',
  imports: [HrAssistantIconComponent, TranslatePipe],
  templateUrl: './hr-assistant-trigger.component.html',
  styleUrl: './hr-assistant-trigger.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(mouseenter)': 'hover.set(true)',
    '(mouseleave)': 'hover.set(false)',
  },
})
export class HrAssistantTriggerComponent {
  public withHover = input(false);
  public forceHoverState = input(false);

  protected hover = signal(false);
  protected isHover = computed(() => (this.withHover() && this.hover()) || this.forceHoverState());
}
